/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * https://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

import { ceIn, addImg, ce } from 'src/kernel/dom'
import { getStr } from '../kernel/kernel'
import MacroDlg from './MacroDlg'
import ListeMacros from './ListeMacros'
import $ from 'jquery'
import AvertDlg from './AvertDlg'

export default MacSuiteMacDlg

/**
 * Dialogue de création ou modification d'une macro d'exécution d'une suite de macros
 * @constructor
 * @param {MtgApp} app La mtgApp propriétaire
 * @param mac La macro qui doit être modifiée
 * @param modification {boolean} : true si le dialogue est ouvert pour modifier une macro déjà existante
 */
function MacSuiteMacDlg (app, mac, modification, callBackOK, callBackCancel) {
  MacroDlg.call(this, app, mac, modification, callBackOK, callBackCancel)
  let i; let btn
  const self = this
  const list = app.listePr
  const indmax = modification ? list.indexOf(mac) - 1 : list.longueur() - 1
  const tabPrincipal = ce('table', {
    cellspacing: 2
  })
  this.appendChild(tabPrincipal)
  // Ajout de l'éditeur d'intitulé /////////////////////////////////
  this.addEditInt(tabPrincipal)
  /// ///////////////////////////////////////////////////////////////
  // Ajout du pane d'information sur la macro //////////////////////
  this.addPaneInfo(tabPrincipal)
  /// ///////////////////////////////////////////////////////////////
  // Ajout du pane pour présenter les deux listes de macros ////////
  let tr = ceIn(tabPrincipal, 'tr')
  const tabCentre = ceIn(tr, 'table')
  tr = ceIn(tabCentre, 'tr')
  let td = ceIn(tr, 'td')
  const tabCentreGauche = ceIn(td, 'table')
  td = ceIn(tr, 'td')
  $(td).css('vertical-align', 'top')
  const tabCentreDroit = ceIn(td, 'table')
  tr = ceIn(tabCentreDroit, 'tr')
  td = ceIn(tr, 'td')
  let caption = ceIn(td, 'caption', {
    class: 'mtgcaption',
    style: 'width:220px'
  })
  $(caption).html(getStr('MacDispo'))
  this.listMacG = new ListeMacros(app, true, indmax, function () {
    self.addFin()
  }, false)
  td.appendChild(this.listMacG.select)
  let btns = ['Ins', 'AddDeb', 'AddFin']
  for (i = 0; i < 3; i++) {
    tr = ceIn(tabCentreGauche, 'tr')
    btn = ceIn(tr, 'button', {
      tabindex: -1,
      style: 'width:220px;font-size:13px'
    })
    btn.owner = this
    btn.onclick = self['onBtn' + btns[i]]
    $(btn).html(getStr(btns[i]))
  }
  tr = ceIn(tabCentreDroit, 'tr')
  td = ceIn(tr, 'td')
  $(td).css('vertical-align', 'top')
  caption = ceIn(td, 'caption', {
    class: 'mtgcaption',
    style: 'width:220px'
  })
  $(caption).html(getStr('MacAExec'))
  // Un tableau pour contenir la liste de droite et les flèches haut et bas
  const tabListe = ceIn(td, 'table')
  const trtab = ceIn(tabListe, 'tr')
  let tdtab = ceIn(trtab, 'td')
  this.listMacD = new ListeMacros(app, false, indmax, null, false)
  if (modification) this.listMacD.addMacrosOf(mac)
  tdtab.appendChild(this.listMacD.select)
  btns = ['Ret', 'RetAll']
  for (i = 0; i < 2; i++) {
    tr = ceIn(tabCentreDroit, 'tr')
    btn = ceIn(tr, 'button', {
      tabindex: -1,
      style: 'width:220px;font-size:13px'
    })
    btn.owner = this
    btn.onclick = self['onBtn' + btns[i]]
    $(btn).html(getStr(btns[i]))
  }

  // Une dernière colonne pour contenir les flèches de déplacement
  tdtab = ceIn(trtab, 'td')
  $(tdtab).css('vertical-align', 'center')
  const tabIcones = ceIn(tdtab, 'table')
  for (const side of ['up', 'down']) {
    tr = ceIn(tabIcones, 'tr')
    td = ceIn(tr, 'td')
    td.owner = this
    td.style.padding = '1px'
    addImg(td, side)
    td.onclick = this[side]
  }

  /// ///////////////////////////////////////////////////////////////
  this.addPaneBas(tabPrincipal)
  this.create('MacSuiteMac', 550)
}

MacSuiteMacDlg.prototype = new MacroDlg()

MacSuiteMacDlg.prototype.OK = function () {
  const mac = this.mac
  const ch = $('#inputint').val()
  if (ch !== '') {
    const list = this.listMacD.getList()
    if (list.longueur() !== 0) {
      this.saveBasic()
      mac.listeAssociee = list
      if (this.modification) this.app.gestionnaire.enregistreFigureEnCours('ModifObj')
      this.destroy()
      if (this.callBackOK !== null) this.callBackOK()
    } else new AvertDlg(this.app, 'ErrNoMac')
  } else this.avertIncorrect()
}

MacSuiteMacDlg.prototype.up = function () {
  this.owner.listMacD.up()
}

MacSuiteMacDlg.prototype.down = function () {
  this.owner.listMacD.down()
}

MacSuiteMacDlg.prototype.onBtnIns = function () {
  const owner = this.owner
  owner.listMacD.insert(owner.listMacG.getSelectedItem())
}

MacSuiteMacDlg.prototype.onBtnAddDeb = function () {
  const owner = this.owner
  owner.listMacD.insertDeb(owner.listMacG.getSelectedItem())
}

MacSuiteMacDlg.prototype.onBtnAddFin = function () {
  this.owner.addFin()
}

MacSuiteMacDlg.prototype.addFin = function () {
  this.listMacD.add(this.listMacG.getSelectedItem())
}

MacSuiteMacDlg.prototype.onBtnRet = function () {
  const owner = this.owner
  owner.listMacD.ret()
}

MacSuiteMacDlg.prototype.onBtnRetAll = function () {
  const owner = this.owner
  owner.listMacD.retAll()
}
